<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <BreadCrumd
          :title="'Nomenclatures'"
          :description="'Nouvelle nomenclature'"
        />
      </div>
      <div class="col-md-12 col-lg-6 mt-4">
        <div class="row" v-if="selectedProduit">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex">
                  <td class="col-12 text-center font-weight-bold">
                    Produit concerné
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-8 text-custom-primary">
                    Désignation : {{ selectedProduit.designation }}
                  </td>
                  <td class="col-4 text-custom-primary">
                    Référence : {{ selectedProduit.reference }}
                  </td>
                </tr>
                <tr class="d-flex">
                  <td class="col-6 font-weight-bold">
                    Type : {{ selectedProduit.type }}
                  </td>
                  <td class="col-6 font-weight-bold">
                    Stock :
                    {{ selectedProduit.stock + ' ' + selectedProduit.unite }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <b-alert
          :show="form.errors.has('produit')"
          dismissible
          variant="danger"
          class="mt-1"
        >
          <span v-html="form.errors.get('produit')"></span>
        </b-alert>
        <div class="row">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-custom-primary mr-4"
              style="min-width: 100px"
              @click="showModalSelectNmProduit()"
            >
              Choisir le produit
            </button>
            <button
              type="button"
              class="btn btn-danger"
              style="min-width: 100px"
              @click="unSelectNmProduit"
            >
              Dissocier le produit
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row d-flex justify-content-lg-center">
                  <div class="col-md-6 col-lg-3">
                    <div class="form-group">
                      <label for="libelle"
                        >Libellé <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('libelle') }"
                        id="libelle"
                        v-model="form.libelle"
                        type="text"
                        placeholder="Libellé"
                        maxlength="100"
                      />
                      <has-error :form="form" field="libelle"></has-error>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <div class="form-group">
                      <label for="quantite_reference"
                        >Quantité de référence
                        <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('quantite_reference'),
                        }"
                        id="quantite_reference"
                        v-model="form.quantite_reference"
                        type="text"
                        placeholder="Quantité de référence"
                      />
                      <has-error
                        :form="form"
                        field="quantite_reference"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-2">
                    <div class="form-group">
                      <label for="quantite_min"
                        >Quantité min <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('quantite_min'),
                        }"
                        id="quantite_min"
                        v-model="form.quantite_min"
                        type="text"
                        placeholder="Quantité min"
                      />
                      <has-error :form="form" field="quantite_min"></has-error>
                    </div>
                  </div>

                  <div class="col-md-2 col-lg-1 mt-3 pt-1">
                    <switches
                      text-enabled="Statut actif"
                      text-disabled="Statut inactif"
                      v-model="form.statut"
                      type-bold="true"
                      color="custom-primary"
                      class="ml-1 mb-0 font-size-17"
                    ></switches>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="selectedProduit">
          <b-alert
            :show="form.errors.has('customError')"
            dismissible
            variant="danger"
          >
            {{ form.errors.get('customError') }}
          </b-alert>
          <div class="row mt-n4">
            <div class="col-lg-12">
              <div role="tablist">
                <b-card
                  no-body
                  class="mb-2"
                  v-for="(item, index) in item_lists"
                  :key="index"
                >
                  <b-card-header
                    header-tag="header"
                    role="tab"
                    v-b-toggle="'accordion-' + (index + 1)"
                    header-class="bg-silver"
                  >
                    <span class="when-open">
                      <h6 class="m-0">
                        <a class="text-dark" href="javascript: void(0);">{{
                          item.libelle
                            ? 'Etape ' + (index + 1) + ' : ' + item.libelle
                            : 'Etape ' + (index + 1)
                        }}</a>
                        <span class="accicon">
                          <a
                            class="cursor-pointer"
                            @click.stop="addEtape"
                            v-if="index === item_lists.length - 1 && !lastItem"
                          >
                            <i
                              :class="create.ICON_PLUS"
                              class="font-size-17 text-success mr-4"
                            ></i
                          ></a>
                          <a
                            class="cursor-pointer"
                            @click.stop="removeEtape(index)"
                            v-if="index > 0"
                          >
                            <i
                              :class="create.ICON_TRASH"
                              class="font-size-17 text-danger mr-4"
                            ></i
                          ></a>
                          <i :class="create.ICON_ANGLE_UP"></i>
                        </span>
                      </h6>
                    </span>
                    <span class="when-closed">
                      <h6 class="m-0">
                        <a class="text-dark" href="javascript: void(0);">{{
                          item.libelle
                            ? 'Etape ' + (index + 1) + ' : ' + item.libelle
                            : 'Etape ' + (index + 1)
                        }}</a>
                        <span class="accicon">
                          <a
                            class="cursor-pointer"
                            @click.stop="addEtape"
                            v-if="index === item_lists.length - 1 && !lastItem"
                          >
                            <i
                              :class="create.ICON_PLUS"
                              class="font-size-17 text-success mr-4"
                            ></i
                          ></a>
                          <a
                            class="cursor-pointer"
                            @click.stop="removeEtape(index)"
                            v-if="index > 0"
                          >
                            <i
                              :class="create.ICON_TRASH"
                              class="font-size-17 text-danger mr-4"
                            ></i
                          ></a>
                          <i :class="create.ICON_ANGLE_DOWN"></i>
                        </span>
                      </h6>
                    </span>
                  </b-card-header>
                  <b-collapse
                    style="background-color: #f3f3f3"
                    :id="'accordion-' + (index + 1)"
                    :visible="index === visibleEtape"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-alert
                      :show="
                        form.errors.has('item_lists.' + index + '.identifiant')
                      "
                      dismissible
                      variant="danger"
                      class="mt-1 mb-0"
                    >
                      {{
                        form.errors.get('item_lists.' + index + '.identifiant')
                      }}
                    </b-alert>
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-6 col-lg-4 col-xl-4">
                            <div class="form-group">
                              <label :for="'item_lists.' + index + '.libelle'"
                                >Libellé de l'étape
                                <span class="text-danger">*</span></label
                              >
                              <input
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'item_lists.' + index + '.libelle'
                                  ),
                                }"
                                :id="'item_lists.' + index + '.libelle'"
                                v-model="item.libelle"
                                type="text"
                                placeholder="Libellé de l'étape"
                                maxlength="50"
                              />
                              <has-error
                                :form="form"
                                :field="'item_lists.' + index + '.libelle'"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4 col-xl-3">
                            <div class="form-group">
                              <label for="poste_charge"
                                >Poste de charge
                                <span class="text-danger">*</span></label
                              >
                              <v-custom-select
                                label="nom"
                                :options="posteCharges"
                                :reduce="(posteCharge) => posteCharge.uuid"
                                v-model="item.poste_charge"
                                placeholder="Poste de charge"
                              >
                                <template v-slot:option="{ nom, entrepot }">
                                  <h5 style="margin: 0">{{ nom }}</h5>
                                  <span v-if="entrepot" class="d-block">
                                    Entrepôt : {{ entrepot.nom }}
                                  </span>
                                </template>
                                <template #no-options> Aucune donnée </template>
                                <template #search="{ attributes, events }">
                                  <input
                                    id="poste_charge"
                                    class="custom-select-height vs__search"
                                    v-bind="attributes"
                                    v-on="events"
                                  />
                                </template>
                              </v-custom-select>
                              <div>
                                <input
                                  type="hidden"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'item_lists.' + index + '.poste_charge'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  :field="
                                    'item_lists.' + index + '.poste_charge'
                                  "
                                ></has-error>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4 col-xl-2">
                            <div class="form-group">
                              <div>
                                <label for="nature"
                                  >Nature de l'étape
                                  <span class="text-danger">*</span></label
                                >
                              </div>
                              <div
                                class="custom-control custom-checkbox custom-control-inline mr-4"
                              >
                                <input
                                  type="checkbox"
                                  :id="'debut' + index"
                                  v-model="item.debut"
                                  class="custom-control-input"
                                  :disabled="
                                    firstItem &&
                                    firstItem.identifiant != item.identifiant
                                  "
                                  @change="onChangeNature(item)"
                                />
                                <label
                                  class="custom-control-label"
                                  :style="
                                    firstItem &&
                                    firstItem.identifiant != item.identifiant
                                      ? 'text-decoration: line-through'
                                      : ''
                                  "
                                  :for="'debut' + index"
                                  >Début</label
                                >
                              </div>
                              <div
                                class="custom-control custom-checkbox custom-control-inline"
                              >
                                <input
                                  type="checkbox"
                                  :id="'fin' + index"
                                  v-model="item.fin"
                                  class="custom-control-input"
                                  :disabled="
                                    lastItem &&
                                    lastItem.identifiant != item.identifiant
                                  "
                                  @change="onChangeNature(item)"
                                />
                                <label
                                  class="custom-control-label"
                                  :for="'fin' + index"
                                  :style="
                                    lastItem &&
                                    lastItem.identifiant != item.identifiant
                                      ? 'text-decoration: line-through'
                                      : ''
                                  "
                                  >Fin</label
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-4 col-xl-3">
                            <div class="form-group">
                              <label
                                :for="'item_lists.' + index + '.dependances'"
                                >Dépendances de l'étape
                                <span class="text-danger">*</span>
                              </label>

                              <multiselect
                                v-model="item.selectedDependances"
                                :options="dependanceEtapes(item, index)"
                                :multiple="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Dépendances de l'étape"
                                label="libelle"
                                track-by="libelle"
                                :disabled="item.debut"
                              >
                              </multiselect>
                              <div>
                                <input
                                  type="hidden"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'item_lists.' + index + '.dependances'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  :field="
                                    'item_lists.' + index + '.dependances'
                                  "
                                ></has-error>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="form-group">
                              <label
                                :for="'item_lists.' + index + '.checklists'"
                                >Les checklists de contrôle qualité
                                <span class="text-danger">*</span>
                              </label>

                              <multiselect
                                v-model="item.selectedChecklists"
                                :options="checklists"
                                :multiple="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Les checklists de contrôle qualité"
                                label="nom"
                                track-by="nom"
                              >
                              </multiselect>
                              <div>
                                <input
                                  type="hidden"
                                  class="form-control"
                                  :class="{
                                    'is-invalid': form.errors.has(
                                      'item_lists.' + index + '.checklists'
                                    ),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  :field="'item_lists.' + index + '.checklists'"
                                ></has-error>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-n4">
                      <div class="col-md-12 col-lg-6">
                        <b-alert
                          :show="
                            form.errors.has('item_lists.' + index + '.matieres')
                          "
                          dismissible
                          variant="danger"
                        >
                          {{
                            form.errors.get('item_lists.' + index + '.matieres')
                          }}
                        </b-alert>
                        <b-card
                          no-body
                          class="text-black"
                          header-class="bg-silver"
                        >
                          <template v-slot:header>
                            <div class="row">
                              <div
                                class="col-md-12 col-lg-9 text-lg-left text-center"
                              >
                                <span class="font-weight-bold"
                                  >Consommation des matières premières</span
                                >
                              </div>
                              <div
                                class="col-md-12 col-lg-3 text-lg-right text-center"
                              >
                                <div
                                  class="d-inline"
                                  @click="
                                    showModalSelectEtapeArticle(
                                      item,
                                      index,
                                      'consommation'
                                    )
                                  "
                                >
                                  <i
                                    :class="create.ICON_EDIT"
                                    class="text-custom-primary font-size-17"
                                  ></i>
                                </div>
                                <div
                                  class="ml-4 d-inline"
                                  @click="
                                    showModalAddArticle(item, 'consommation')
                                  "
                                >
                                  <i
                                    class="fa fa-plus text-custom-primary font-size-17"
                                  ></i>
                                </div>
                              </div>
                            </div>
                          </template>
                          <div class="row">
                            <div class="col-12">
                              <table class="table table-sm">
                                <thead>
                                  <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Désignation</th>
                                    <th scope="col">Référence</th>
                                    <th scope="col">Quantité</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template
                                    v-for="(article, index3) in item.matieres"
                                  >
                                    <tr :key="index3">
                                      <th scope="row">{{ index3 + 1 }}</th>
                                      <td>
                                        {{ article.designation }}
                                      </td>
                                      <td>{{ article.reference }}</td>
                                      <td>
                                        <div
                                          class="input-group input-group-sm"
                                          style="width: 150px"
                                        >
                                          <input
                                            class="form-control form-control-sm"
                                            v-model="article.quantite"
                                            type="text"
                                            placeholder="Quantité"
                                            @focus="$event.target.select()"
                                          />
                                          <div
                                            class="input-group-append bg-transparent"
                                          >
                                            <span
                                              class="input-group-text bg-transprent"
                                            >
                                              {{ article.unite }}
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr
                                      class="error-tr text-center small"
                                      :key="index3 + '-m-error'"
                                      v-if="
                                        form.errors.has(
                                          'item_lists.' +
                                            index +
                                            '.matieres.' +
                                            index3 +
                                            '.uuid'
                                        ) ||
                                        form.errors.has(
                                          'item_lists.' +
                                            index +
                                            '.matieres.' +
                                            index3 +
                                            '.quantite'
                                        )
                                      "
                                    >
                                      <td colspan="3" class="text-danger">
                                        {{
                                          form.errors.get(
                                            'item_lists.' +
                                              index +
                                              '.matieres.' +
                                              index3 +
                                              '.uuid'
                                          )
                                        }}
                                      </td>
                                      <td class="text-danger">
                                        {{
                                          form.errors.get(
                                            'item_lists.' +
                                              index +
                                              '.matieres.' +
                                              index3 +
                                              '.quantite'
                                          )
                                        }}
                                      </td>
                                    </tr>
                                  </template>

                                  <tr v-if="item.matieres.length === 0">
                                    <td class="text-center" colspan="4">
                                      Aucune donnée
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </b-card>
                      </div>
                      <div class="col-md-12 col-lg-6">
                        <b-alert
                          :show="
                            form.errors.has('item_lists.' + index + '.produits')
                          "
                          dismissible
                          variant="danger"
                        >
                          {{
                            form.errors.get('item_lists.' + index + '.produits')
                          }}
                        </b-alert>
                        <b-card
                          no-body
                          class="text-black"
                          header-class="bg-silver"
                        >
                          <template v-slot:header>
                            <div
                              class="row"
                              v-if="
                                lastItem &&
                                lastItem.identifiant === item.identifiant
                              "
                            >
                              <div class="col-md-12 text-md-left text-center">
                                <span class="font-weight-bold"
                                  >Produit fini à fabriquer
                                </span>
                              </div>
                            </div>
                            <div class="row" v-else>
                              <div
                                class="col-md-12 col-lg-9 text-lg-left text-center"
                              >
                                <span class="font-weight-bold"
                                  >Produits semi-finis à fabriquer
                                </span>
                              </div>
                              <div
                                class="col-md-12 col-lg-3 text-lg-right text-center"
                              >
                                <div
                                  class="d-inline"
                                  @click="
                                    showModalSelectEtapeArticle(
                                      item,
                                      index,
                                      'production'
                                    )
                                  "
                                >
                                  <i
                                    :class="create.ICON_EDIT"
                                    class="text-custom-primary font-size-17"
                                  ></i>
                                </div>
                                <div
                                  class="ml-4 d-inline"
                                  @click="
                                    showModalAddArticle(item, 'production')
                                  "
                                >
                                  <i
                                    class="fa fa-plus text-custom-primary font-size-17"
                                  ></i>
                                </div>
                              </div>
                            </div>
                          </template>
                          <div class="row">
                            <div class="col-12">
                              <table class="table table-sm">
                                <thead>
                                  <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Désignation</th>
                                    <th scope="col">Référence</th>
                                    <th scope="col">Quantité</th>
                                  </tr>
                                </thead>
                                <tbody
                                  v-if="
                                    lastItem &&
                                    lastItem.identifiant === item.identifiant
                                  "
                                >
                                  <tr>
                                    <th scope="row">1</th>
                                    <td>
                                      {{ selectedProduit.designation }}
                                    </td>
                                    <td>{{ selectedProduit.reference }}</td>
                                    <td>
                                      {{
                                        form.quantite_reference +
                                        ' ' +
                                        selectedProduit.unite
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody v-else>
                                  <template
                                    v-for="(article, index3) in item.produits"
                                  >
                                    <tr :key="index3">
                                      <th scope="row">{{ index3 + 1 }}</th>
                                      <td>
                                        {{ article.designation }}
                                      </td>
                                      <td>{{ article.reference }}</td>
                                      <td>
                                        <div
                                          class="input-group input-group-sm"
                                          style="width: 150px"
                                        >
                                          <input
                                            class="form-control form-control-sm"
                                            v-model="article.quantite"
                                            type="text"
                                            placeholder="Quantité"
                                            @focus="$event.target.select()"
                                          />
                                          <div
                                            class="input-group-append bg-transparent"
                                          >
                                            <span
                                              class="input-group-text bg-transprent"
                                            >
                                              {{ article.unite }}
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr
                                      class="error-tr text-center small"
                                      :key="index3 + '-p-error'"
                                      v-if="
                                        form.errors.has(
                                          'item_lists.' +
                                            index +
                                            '.produits.' +
                                            index3 +
                                            '.uuid'
                                        ) ||
                                        form.errors.has(
                                          'item_lists.' +
                                            index +
                                            '.produits.' +
                                            index3 +
                                            '.quantite'
                                        )
                                      "
                                    >
                                      <td colspan="3" class="text-danger">
                                        {{
                                          form.errors.get(
                                            'item_lists.' +
                                              index +
                                              '.produits.' +
                                              index3 +
                                              '.uuid'
                                          )
                                        }}
                                      </td>
                                      <td class="text-danger">
                                        {{
                                          form.errors.get(
                                            'item_lists.' +
                                              index +
                                              '.produits.' +
                                              index3 +
                                              '.quantite'
                                          )
                                        }}
                                      </td>
                                    </tr>
                                  </template>

                                  <tr v-if="item.produits.length === 0">
                                    <td class="text-center" colspan="4">
                                      Aucune donnée
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </b-card>
                      </div>
                    </div>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="
                $router.push({ name: 'gpao_nomenclature' }).catch(() => {})
              "
            >
              Liste des nomenclatures
            </button>

            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Créer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
    <ModalSelectArticle
      ref="modalSelectArticle"
      :currentItem="currentItem"
      :currentArticles="currentArticles"
      :currentType="currentType"
      :selectedProduit="selectedProduit"
      :currentIndex="currentIndex"
      :titleModal="titleModal"
      @onArticleEtapeSelected="onArticleEtapeSelected"
    />
    <ModalSelectProduit
      ref="modalSelectProduit"
      :selectedProduit="selectedProduit"
      :titleModal="titleModal"
      @onProduitSelected="onProduitSelected"
    />
    <ModalAddArticle
      ref="modalAddArticle"
      :currentType="currentType"
      @onSavedArticle="onSavedArticle"
    />
  </div>
</template>

<script>
import URL from '@/http/gpao/nomenclature';
import { create } from '@/icons/gpao/nomenclature';
import Form from 'vform';
import ModalSelectProduit from '../components/ModalSelectProduit.vue';
import ModalSelectArticle from '../components/ModalSelectArticle.vue';
import ModalAddArticle from '../components/ModalAddArticle.vue';
import { uuid } from 'vue-uuid';

export default {
  data() {
    return {
      create,

      form: new Form({
        produit: '',
        libelle: '',
        quantite_reference: 1,
        quantite_min: 1,
        statut: true,
      }),
      item_lists: [],
      currentItem: null,
      currentArticles: [],
      currentType: null,
      currentIndex: null,
      selectedProduit: null,
      checklists: [],
      posteCharges: [],
      titleModal: '',
      cloneId: null,

      visibleEtape: 0,

      title: 'Gestion des nomenclatures - Création',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    ModalSelectArticle,
    ModalSelectProduit,
    ModalAddArticle,
  },
  computed: {
    firstItem() {
      return this.item_lists.find((item) => item.debut === true) || null;
    },
    lastItem() {
      return this.item_lists.find((item) => item.fin === true) || null;
    },
  },
  methods: {
    init() {
      this.checklists = [];
      this.posteCharges = [];
      this.currentItem = null;
      this.currentArticles = [];
      this.currentType = null;
      this.currentIndex = null;
      this.selectedProduit = null;

      if (this.$route.params.cloneId) {
        this.cloneId = this.$route.params.cloneId;

        this.item_lists = [];

        window.axios
          .all([
            window.axios.get(URL.NOMENCLATURE + '/' + this.cloneId, {
              params: {
                edit: true,
              },
            }),
            window.axios.get(URL.GET_REQUIREMENTS),
          ])
          .then(
            window.axios.spread((resp1, resp2) => {
              Object.assign(this.form, resp1.data.nomenclature);
              this.checklists = resp2.data.checklists;
              this.posteCharges = resp2.data.poste_charges;
              this.selectedProduit = this.form.produit;
              this.item_lists = this.form.item_lists.map((item) => {
                return {
                  nomenclature_uuid: item.nomenclature_uuid,
                  identifiant: item.identifiant,
                  libelle: item.libelle,
                  poste_charge: item.poste_charge,
                  debut: item.debut,
                  fin: item.fin,
                  matieres: item.matieres,
                  produits: item.produits,
                  selectedDependances: item.selected_dependances,
                  selectedChecklists: item.selected_checklists,
                };
              });
              delete this.form.produit;
              delete this.form.item_lists;
            })
          )
          .catch();
      } else {
        this.item_lists = [
          {
            identifiant: uuid.v4(),
            libelle: '',
            poste_charge: '',
            debut: true,
            fin: false,
            matieres: [],
            produits: [],
            selectedDependances: [],
            selectedChecklists: [],
          },
        ];

        window.axios
          .get(URL.GET_REQUIREMENTS)
          .then((resp) => {
            this.checklists = resp.data.checklists;
            this.posteCharges = resp.data.poste_charges;
          })
          .catch();
      }
    },
    showModalSelectNmProduit() {
      this.titleModal = 'Sélection du produit de la nomenclature';
      this.$nextTick(() => {
        this.$refs.modalSelectProduit.showModal();
      });
    },
    unSelectNmProduit() {
      this.titleModal = '';
      this.selectedProduit = null;
      this.form.reset();
      this.init();
    },
    onProduitSelected(produit) {
      this.selectedProduit = produit;
    },
    showModalSelectEtapeArticle(item, index, type) {
      this.titleModal =
        type === 'consommation'
          ? 'Sélection des matières premières'
          : 'Sélection des produits à fabriquer';

      if (type === 'consommation') {
        this.currentArticles =
          item.matieres.filter((article) => article.type === 'consommation') ||
          [];
      } else {
        this.currentArticles =
          item.produits.filter((article) => article.type === 'production') ||
          [];
      }

      this.currentItem = item;
      this.currentType = type;
      this.currentIndex = index;
      this.$nextTick(() => {
        this.$refs.modalSelectArticle.showModal();
      });
    },
    onArticleEtapeSelected(currentArticles) {
      if (this.currentType === 'consommation') {
        this.currentItem.matieres = currentArticles;
      } else {
        this.currentItem.produits = currentArticles;
      }

      this.currentItem = null;
      this.currentType = null;
      this.currentIndex = null;
      this.currentArticles = [];
    },
    showModalAddArticle(item, type) {
      this.currentItem = item;
      this.currentType = type;

      this.$nextTick(() => {
        this.$refs.modalAddArticle.showModal();
      });
    },
    onSavedArticle(article) {
      if (this.currentType === 'consommation') {
        this.currentItem.matieres.push(article);
      } else {
        this.currentItem.produits.push(article);
      }
      this.currentItem = null;
      this.currentType = null;
    },
    onChangeNature(item) {
      if (item.debut) {
        item.dependances = [];
        item.selectedDependances = [];
      }
      item.produits = item.produits = item.produits.filter(
        (produit) => produit.uuid !== this.selectedProduit.uuid
      );
    },
    dependanceEtapes(item, index) {
      if (item.debut) return [];

      return this.item_lists
        .filter((itemF, indexF) => indexF < index && itemF.libelle)
        .map((item) => {
          return {
            identifiant: item.identifiant,
            libelle: item.libelle,
          };
        });
    },
    addEtape() {
      this.item_lists.push({
        identifiant: uuid.v4(),
        libelle: '',
        poste_charge: '',
        debut: this.item_lists.length === 0,
        fin: false,
        matieres: [],
        produits: [],
        selectedDependances: [],
        selectedChecklists: [],
      });
      this.visibleEtape = this.item_lists.length - 1;
    },
    removeEtape(index) {
      this.item_lists.splice(index, 1);
    },
    submit() {
      this.visibleEtape = -1;

      if (this.selectedProduit) {
        this.form.produit = this.selectedProduit.resource_uuid;
      }

      let produit = [
        {
          uuid: this.selectedProduit.uuid,
          designation: this.selectedProduit.designation,
          reference: this.selectedProduit.reference,
          unite: this.selectedProduit.unite,
          quantite: this.form.quantite_reference,
          stock: this.selectedProduit.stock,
          type: this.selectedProduit.type,
        },
      ];

      this.form.item_lists = this.item_lists.map((item) => {
        return {
          identifiant: item.identifiant,
          libelle: item.libelle,
          poste_charge: item.poste_charge,
          debut: item.debut,
          fin: item.fin,
          matieres: item.matieres,
          produits: item.fin ? produit : item.produits,
          dependances: item.selectedDependances.map(
            (dependance) => dependance.identifiant
          ),
          checklists: item.selectedChecklists.map(
            (checklist) => checklist.uuid
          ),
        };
      });

      this.form
        .post(URL.NOMENCLATURE)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          if (this.cloneId) {
            this.cloneId = null;
          }
          this.$router.push({
            name: 'gpao_nomenclature-show',
            params: { id: resp.data.nomenclature.id },
          });
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('item_lists')) {
              this.visibleEtape = Number(key[10]);
              return false;
            }
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.error-tr td {
  padding: 0 0 0.5rem 0;
  margin: -10px;
  border-top: 0;
}

.card-header .accicon {
  float: right;
}
.card-header {
  cursor: pointer;
  border-bottom: 5px;
}
.card {
  border: 1px solid #ddd;
}

.bg-silver {
  background-color: transparent;
  border-color: #ced4da;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
